// extracted by mini-css-extract-plugin
export default {"form-wrapper":"FormWrapper_form-wrapper__xOr11"};